module.exports = __webpack_public_path__ + "static/img/product5.6d29f8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/white/product5.png
// module id = TXu6
// module chunks = 0